import './importPaletteForm.less';

import React, { FC } from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';

import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput, AntTextArea } from 'controls/react/ant/antInput';
import { translator } from 'core/localization';
import { ImportPaletteFormProps } from 'controls/react/color-picker/components/import-palette-form/types';
import { MAX_COLORS_PER_PALETTE } from 'controls/react/color-picker/constants';
import { Section } from 'controls/react/layout/section';
import { Toolbar } from 'controls/react/layout/toolbar';
import { ActionButtons } from 'controls/react/form';

const i18n = translator({
	'Name': { no: 'Navn' },
	'Colors (JSON array or comma-separated hex values)': { no: 'Farger (JSON-liste eller kommaseparerte hex-verdier)' },
	'Only the first {0} colors will be imported': { no: 'Bare de første {0} fargene importeres' },
});

const b = b_.with('import-palette-form');

export const ImportPaletteForm: FC<ImportPaletteFormProps> = observer(({ store }) => {
	return (
		<Section containerClass={b()} childrenPadding={true} hasFooter={true}>
			<FormEntryNew label={i18n('Name')} model={store} modelField={'name'} validator={store.validator}>
				<AntInput autoFocus />
			</FormEntryNew>
			<FormEntryNew
				label={i18n('Colors (JSON array or comma-separated hex values)')}
				model={store}
				modelField={'json'}
				validator={store.validator}
			>
				<AntTextArea autoSize={{ minRows: 4, maxRows: 8 }} />
			</FormEntryNew>

			{store.validator.valid && store.truncated && (
				<div className={b('hint')}>{i18n('Only the first {0} colors will be imported', MAX_COLORS_PER_PALETTE)}</div>
			)}

			{store.validator.valid && store.validColors.length > 0 && (
				<div className={b('preview')}>
					{store.validColors.slice(0, MAX_COLORS_PER_PALETTE).map((hex, index) => (
						<div key={index} className={b('preview-swatch')} style={{ backgroundColor: hex }} title={hex} />
					))}
				</div>
			)}
			<Toolbar>
				<ActionButtons
					validator={store.validator}
					onSave={() => store.closeModal(true)}
					onCancel={() => store.closeModal(false)}
				/>
			</Toolbar>
		</Section>
	);
});
